export default __webpack_public_path__ + "static/media/BG-DarkBlue-0005.b0325dc2.png";